import { defineStore } from "pinia";
// import userData from '../views/GoogleLogin.vue'

export const useWarehouseStore = defineStore("warehouse", {
    state: () => ({
        warehouse: [],
    }),

    actions: {
        setWarehouse(warehouse) {
            console.log("Setting Warehouse", warehouse);
            return this.warehouse = warehouse
        },
        getWarehouse() {
            return this.warehouse
        }
    }
})